import * as React from 'react';

function SvgBellNotificationStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.432 6.675a7.1 7.1 0 01.754 0v-.367a.377.377 0 00-.754 0v.367zm2.154.22v-.587a1.777 1.777 0 00-3.554 0v.588a6.977 6.977 0 00-5.19 6.744v4.671a.611.611 0 01-.297.524l-.039.024a2.01 2.01 0 00-.975 1.724v.51c0 1.111.9 2.012 2.011 2.012h3.747v.011a2.53 2.53 0 005.058 0v-.01h3.746c1.11 0 2.012-.902 2.012-2.013v-.51a2.01 2.01 0 00-.978-1.725l-.033-.02a.613.613 0 01-.301-.527v-4.52c0-3.276-2.2-6.09-5.207-6.896zm-.64 16.21h-2.258v.011a1.13 1.13 0 002.259 0v-.01zm4.447-4.794v-4.52c0-3.062-2.383-5.616-5.371-5.723a5.575 5.575 0 00-5.78 5.572v4.671a2.01 2.01 0 01-.975 1.724l-.04.024a.611.611 0 00-.296.524v.51c0 .338.274.612.611.612h12.55a.612.612 0 00.613-.611v-.511a.613.613 0 00-.302-.527l-.033-.02a2.011 2.011 0 01-.977-1.725z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgBellNotificationStroke;
